import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-1c37ea98"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "service-wrap pt-20 pb-20" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "team-card style1" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = {
  key: 1,
  class: "no-photo-placeholder"
}
const _hoisted_7 = { class: "card-initials" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "team-overlay" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-eye" })
], -1))
const _hoisted_9 = { class: "team-info text-center mt-3" }
const _hoisted_10 = { class: "team-designation" }
const _hoisted_11 = { class: "mt-4" }
const _hoisted_12 = {
  key: 0,
  class: "modal-image-container"
}
const _hoisted_13 = ["src", "alt"]
const _hoisted_14 = {
  key: 1,
  class: "modal-initials-container"
}
const _hoisted_15 = { class: "initials-circle" }
const _hoisted_16 = { class: "modal-info" }
const _hoisted_17 = { class: "specialite" }
const _hoisted_18 = {
  key: 0,
  class: "details"
}
const _hoisted_19 = { key: 0 }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Email:", -1))
const _hoisted_21 = { key: 1 }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Téléphone:", -1))
const _hoisted_23 = { key: 2 }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Matricule:", -1))
const _hoisted_25 = { key: 3 }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Date de naissance:", -1))
const _hoisted_27 = { key: 4 }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Lieu de naissance:", -1))
const _hoisted_29 = { key: 5 }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Adresse:", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PaginationComponent = _resolveComponent("PaginationComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.etudiants, (etudiant, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "col-xl-3 col-lg-4 col-md-6",
            key: index
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", {
                class: "team-img",
                onClick: ($event: any) => (_ctx.openModal(etudiant))
              }, [
                (etudiant.user?.urlImage)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      style: _normalizeStyle({
                  height: '300px',
                  backgroundImage: `url(${_ctx.getImageUrl(etudiant.user.urlImage)})`,
                  backgroundSize: 'cover',
                  backgroundPosition: 'center',
                  borderRadius: '10px',
                  cursor: 'pointer'
                })
                    }, null, 4))
                  : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.getInitials(etudiant.nom, etudiant.prenom)), 1)
                    ])),
                _hoisted_8
              ], 8, _hoisted_5),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("h4", null, _toDisplayString(etudiant.nom) + " " + _toDisplayString(etudiant.prenom), 1),
                _createElementVNode("span", _hoisted_10, _toDisplayString(etudiant.filiere || 'Disciple'), 1)
              ])
            ])
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_PaginationComponent, {
          page: _ctx.page,
          totalPages: _ctx.totalPages,
          totalElements: _ctx.totalElements,
          limit: _ctx.limit,
          onPaginate: _ctx.handlePaginate
        }, null, 8, ["page", "totalPages", "totalElements", "limit", "onPaginate"])
      ])
    ]),
    (_ctx.showModal && _ctx.selectedEtudiant)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "photo-modal",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
        }, [
          _createElementVNode("div", {
            class: "modal-content",
            onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
          }, [
            _createElementVNode("span", {
              class: "close-btn",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
            }, "×"),
            (_ctx.selectedEtudiant.user?.urlImage)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createElementVNode("img", {
                    src: _ctx.getImageUrl(_ctx.selectedEtudiant.user.urlImage),
                    alt: _ctx.selectedEtudiant.nom
                  }, null, 8, _hoisted_13)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.getInitials(_ctx.selectedEtudiant.nom, _ctx.selectedEtudiant.prenom)), 1)
                ])),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("h3", null, _toDisplayString(_ctx.selectedEtudiant.nom) + " " + _toDisplayString(_ctx.selectedEtudiant.prenom), 1),
              _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.selectedEtudiant.filiere || 'Disciple'), 1),
              (_ctx.selectedEtudiant)
                ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                    (_ctx.selectedEtudiant.email)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_19, [
                          _hoisted_20,
                          _createTextVNode(" " + _toDisplayString(_ctx.selectedEtudiant.email), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.selectedEtudiant.telephone)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_21, [
                          _hoisted_22,
                          _createTextVNode(" " + _toDisplayString(_ctx.selectedEtudiant.telephone), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.selectedEtudiant.matricule)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_23, [
                          _hoisted_24,
                          _createTextVNode(" " + _toDisplayString(_ctx.selectedEtudiant.matricule), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.selectedEtudiant.dateNaissance)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_25, [
                          _hoisted_26,
                          _createTextVNode(" " + _toDisplayString(_ctx.selectedEtudiant.dateNaissance), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.selectedEtudiant.lieuNaissance)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_27, [
                          _hoisted_28,
                          _createTextVNode(" " + _toDisplayString(_ctx.selectedEtudiant.lieuNaissance), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.selectedEtudiant.adresse)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_29, [
                          _hoisted_30,
                          _createTextVNode(" " + _toDisplayString(_ctx.selectedEtudiant.adresse), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}